module.exports = __webpack_public_path__ + "3f8ae2edfd9e2035ede1ef465a28f112.svg";